import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 8,
	viewBox: "0 0 12 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.00001 6.83006C1.18737 7.01631 1.44082 7.12085 1.70501 7.12085C1.96919 7.12085 2.22264 7.01631 2.41001 6.83006L6.00001 3.29006L9.54001 6.83006C9.72737 7.01631 9.98082 7.12085 10.245 7.12085C10.5092 7.12085 10.7626 7.01631 10.95 6.83006C11.0437 6.73709 11.1181 6.62649 11.1689 6.50463C11.2197 6.38277 11.2458 6.25207 11.2458 6.12006C11.2458 5.98805 11.2197 5.85734 11.1689 5.73548C11.1181 5.61362 11.0437 5.50302 10.95 5.41006L6.71001 1.17006C6.61704 1.07633 6.50644 1.00194 6.38458 0.951166C6.26272 0.900397 6.13202 0.874259 6.00001 0.874259C5.86799 0.874259 5.73729 0.900397 5.61543 0.951166C5.49357 1.00194 5.38297 1.07633 5.29001 1.17006L1.00001 5.41006C0.906278 5.50302 0.831883 5.61362 0.781115 5.73548C0.730346 5.85734 0.704206 5.98805 0.704206 6.12006C0.704206 6.25207 0.730346 6.38277 0.781115 6.50463C0.831883 6.62649 0.906278 6.73709 1.00001 6.83006Z",
		fill: "black"
	})
});
export default SvgUp;
